import type { Task } from '@frontend/api-types';
import { dateFormatters } from '@frontend/duck-tape';
import { CardButton, CardContainer, CardContent, CardHeader, XStack, YStack } from '@frontend/web-react';
import { useNavigate } from '@tanstack/react-router';

type ReviewTaskCardProps = {
  task: Task;
};

export const ReviewTaskCard = ({ task }: ReviewTaskCardProps) => {
  const navigate = useNavigate();
  const { id, name, statusSummary, updatedAt } = task;
  return (
    <CardContainer
      className="justify-between"
      onClick={() => navigate({ params: { taskId: id }, to: '/app/task/$taskId' })}
    >
      <YStack className="gap-lg">
        <CardHeader title={name} />
        <CardContent
          captionBelowDescription={dateFormatters.message(updatedAt)}
          containerClassName="gap-xs"
          description={statusSummary}
        />
      </YStack>
      <XStack className="justify-end">
        <CardButton
          label="Reply"
          onClick={() => navigate({ params: { taskId: id }, to: '/app/task/$taskId' })}
          variant="subtle"
        />
      </XStack>
    </CardContainer>
  );
};
